// frontend/src/components/SearchModal.jsx
import { X, Search } from "lucide-react";

const categoriasOrdenadas = [
  "Artigos Infantis",
  "Aventura e Lazer",
  "Brinquedos e Bicicletas",
  "Celulares",
  "Decoração e Lar",
  "Eletro",
  "Esporte e Fitness",
  "Ferramentas, Construção e Reforma",
  "Hobbies, Musica, Arte e Livros",
  "Home Office",
  "Imóveis",
  "Informática e Games",
  "Moda e Achados de Estilo",
  "Moveis",
  "Mundo Pets",
  "TV, Audio, Video e Drones",
  "Veículos e Autopeças",
];

// 👇 USAR IDs en lugar de nombres
const condominiosDisponiveis = [
  { id: 1, nome: "Gran Ville São Venâncio" },
  { id: 2, nome: "Bela Vista" },
  { id: 3, nome: "Residencial Pecan" },
  { id: 4, nome: "Condomínio Terras da Alvorada" },
];

export default function SearchModal({ 
  isOpen, 
  onClose, 
  searchTerm, 
  setSearchTerm, 
  selectedCategory, 
  setSelectedCategory,
  selectedCondominio,
  setSelectedCondominio,
  onSearch 
}) {
  if (!isOpen) return null;

  const handleSearch = () => {
    onSearch();
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 bg-white animate-slide-up md:hidden">
      <div className="sticky top-0 bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between">
        <h2 className="text-lg font-semibold text-gray-800">Filtrar busca</h2>
        <button
          onClick={onClose}
          className="p-2 rounded-full hover:bg-gray-100 transition-colors"
        >
          <X className="w-5 h-5 text-gray-500" />
        </button>
      </div>

      <div className="p-4 space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            O que você procura?
          </label>
          <div className="relative">
            <input
              type="text"
              placeholder="Digite o que você está procurando..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#449879] focus:border-transparent"
              autoFocus
            />
            <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Categoria
          </label>
          <select
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#449879] focus:border-transparent text-gray-700"
          >
            <option value="">Todas as categorias</option>
            {categoriasOrdenadas.map((categoria) => (
              <option key={categoria} value={categoria}>
                {categoria}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Condomínio
          </label>
          <select
            value={selectedCondominio}
            onChange={(e) => setSelectedCondominio(e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#449879] focus:border-transparent text-gray-700"
          >
            <option value="">Todos os condomínios</option>
            {condominiosDisponiveis.map((condominio) => (
              <option key={condominio.id} value={condominio.id}>
                {condominio.nome}
              </option>
            ))}
          </select>
        </div>

        <div className="flex gap-3 pt-4">
          <button
            onClick={() => {
              setSearchTerm("");
              setSelectedCategory("");
              setSelectedCondominio("");
              onSearch();
              onClose();
            }}
            className="flex-1 py-3 border border-gray-300 rounded-xl text-gray-700 font-medium hover:bg-gray-50 transition-colors"
          >
            Limpar filtros
          </button>
          <button
            onClick={handleSearch}
            className="flex-1 py-3 bg-[#449879] text-white rounded-xl font-medium hover:bg-[#367d64] transition-colors"
          >
            Ver resultados
          </button>
        </div>
      </div>
    </div>
  );
}